module.exports = __webpack_public_path__ + "static/media/BALBT-BNB.623cff04.svg";